'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');

var selectedItemClass = 'gallery-list__item--is-selected';

var getSelectedItem = function() {

	return appDom.galleryList.find('.' + selectedItemClass);

};

var getItemByIndex = function(index) {

	return appDom.galleryList.find('[data-gallery-index="' + index + '"]');

};

// Allow $item to be passed in, since in some cases we will already have it
// to perform other logic.
var unselect = function($item) {

	$item = $item || getSelectedItem();

	$item.removeClass(selectedItemClass);

};

var select = function($item) {

	$item.addClass(selectedItemClass);

};

var updateSelection = function() {

	var $oldGallery = getSelectedItem();
	var $newGallery = getItemByIndex(dataMgr.getGalleryIndex());

	// Avoid toggling the same gallery if user went back/forward from a
	// slideshow.
	if (!$oldGallery.is($newGallery)) {

		// Turn off old highlight.
		unselect($oldGallery);

		// Turn on new highlight.
		select($newGallery);

	}

};

var updateFavoriteCount = function(count) {

	appDom.galleryListFavoriteCount.text(count);

};

var addEventHandlers = function() {

	appDom.document.on('gallery_data_ready', updateSelection);

	appDom.galleryList.on('click', '.gallery-list__item', function() {

		var $this = $(this);

		if ($this.hasClass(selectedItemClass)) {

			// triggerCustomEvent('selected_gallery_list_item_clicked');

		} else {

			// Broadcast the new selected gallery.
			triggerCustomEvent('gallery_list_gallery_selected', {
				data: {
					galleryIndex: parseInt($this.attr('data-gallery-index'), 10)					
				}
			});

		}

	});

	appDom.document.on('favorite_count_updated', function(e, data) {

		updateFavoriteCount(data.count);

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {

	init: init

};
